import { render, staticRenderFns } from "./GoalPlanningHome.vue?vue&type=template&id=af900aae&"
import script from "./GoalPlanningHome.vue?vue&type=script&lang=ts&"
export * from "./GoalPlanningHome.vue?vue&type=script&lang=ts&"
import style0 from "./GoalPlanningHome.vue?vue&type=style&index=0&id=af900aae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports